import { LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT_USER } from '../actions/index';

const initialState = {
	user: null,
	error: null,
	isAuthenticated: null,
	isAdmin: null,
};

const loginReducer = (state = initialState, action) => {
	switch (action.type) {
		case LOGIN_SUCCESS:
			localStorage.setItem('x-auth-token', action.payload.token);
			return {
				...state,
				user: action.payload.token,
				userDetails: action.payload.user,
				error: null, // Clear any previous error
				isAuthenticated: true,
				isAdmin: action.payload.is_admin ? true : false,
			};
		case LOGIN_FAILURE:
		case LOGOUT_USER:
			localStorage.removeItem('x-auth-token');
			return {
				state: null, // Reset user to null on failure
				error: action.payload,
				isAuthenticated: false,
			};
		default:
			return state;
	}
};

export default loginReducer;
